import { UI } from '@skedulo/protobuf-web'
import { UiApiCrudClientBaseV1 } from '../crud-client-base'
import type {
  IApiPage,
  IPageCreateRequest,
  IPageDelRequest,
  IPageGetRequest,
  IPagePutRequest,
  IPageGetManyRequest,
} from '../../../types'

const BASE_PATH = '/v1/pages'

export class PageUiApiClientV1 extends UiApiCrudClientBaseV1<IApiPage> {
  getMany = async (request: IPageGetManyRequest) => {
    const { limit, page, name, slug, ...rest } = request as Record<
      string,
      unknown
    >
    const queryParams = this.buildQueryParams({
      limit,
      page,
      name,
      slug,
      ...rest,
    })
    const response = await this.restGet<{ items: IApiPage[] }>(
      BASE_PATH,
      queryParams,
    )
    if (!response.items) throw new Error('Invalid response: missing "items"')
    return response.items.map((item) => this.getItem(item))
  }

  getItem = (page: IApiPage): IApiPage => ({
    ...page,
    pageType: UI.CRUD.pageTypeFromJSON(page.pageType),
  })

  create = async (request: IPageCreateRequest) =>
    this.restPost<IApiPage>(BASE_PATH, request.page)

  get = async (request: IPageGetRequest) =>
    this.getItem(await this.restGet<IApiPage>(`${BASE_PATH}/${request.uid}`))

  put = async (request: IPagePutRequest) =>
    this.mergeAndPut(BASE_PATH, request.page)

  del = async (request: IPageDelRequest) =>
    this.restDelete(`${BASE_PATH}/${request.uid}`)
}
